import { createSignal } from "solid-js";

export function CopyButton(props: { link: string; compact?: boolean; iconOnly?: boolean }) {
  const [copied, setCopied] = createSignal(false);
  return (
    <button
      onClick={() => { navigator.clipboard.writeText(props.link); setCopied(true); setTimeout(() => setCopied(false), 2000); }}
      class={props.iconOnly
        ? "text-xs px-1.5 py-1 bg-gray-800 text-gray-400 rounded hover:bg-gray-700 cursor-pointer"
        : `${props.compact ? "text-xs px-2 py-1" : "text-xs px-2 py-0.5"} bg-gray-800 text-gray-300 rounded hover:bg-gray-700 cursor-pointer`
      }
      title={props.iconOnly ? props.link : undefined}
    >
      {props.iconOnly ? (copied() ? "✓" : "📋") : (copied() ? "Copied!" : "Copy")}
    </button>
  );
}
